import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  job_title: " ",
  // currentComponent: null
  job_id: null,
};

export const careerSlice = createSlice({
  name: "Career",
  initialState,
  reducers: {
    setJob_title: (state, action) => {
      state.job_title = action.payload;
    },
    setJob_id: (state, action) =>{
      state.job_id = action.payload;
    }
  },
});

export const { setJob_title, setJob_id } = careerSlice.actions;

export default careerSlice.reducer;
